
import { isArray } from 'lodash'

export default function (acl) {
  let checkList = []

  if (isArray(acl)) {
    for (let a of acl) {
      checkList.push({
        pattern: new RegExp(a.pattern),
        allow: !!a.allow
      })
    }
  }

  return {
    check: function (grant) {
      for (let check of checkList) {
        if (check.pattern.test(grant)) {
          return check.allow
        }
      }
    }
  }
}